import { Formik } from "formik";
import { Fragment, useState } from "react";
import { styled } from "@mui/system";
import { useDispatch } from "react-redux";
import { Grid, Paper, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import { useAlert, useAxios } from "../../hooks";
import { signInMember } from "../../redux/slices/memberSlice";
import {
  emailValidationSchema,
  otpValidationSchema,
  signInDetailsObject,
} from "./signInDetailsObject";

const PageContainer = styled(Box)`
  // min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
`;

const FormBox = styled(Paper)`
  width: 100%;
  max-width: 480px;
  padding: 48px 40px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export default function Form() {
  const [isOtpLogin, setIsOtpLogin] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const axios = useAxios({ baseURL: "mox_api_2", disableAuthToken: true });
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const isGuardLogin = queryParams.get("guard_login") === "true";

  return (
    <PageContainer>
      <FormBox elevation={24}>
        <Formik
          enableReinitialize
          initialValues={signInDetailsObject}
          validationSchema={
            isOtpLogin ? otpValidationSchema : emailValidationSchema
          }
          validateOnMount
          onSubmit={async (formData, { setSubmitting }) => {
            try {
              if (isOtpLogin) {
                if (!formData.mobile || !formData.otp) return;
                const res = await axios({
                  url: "/event/volunteer/login",
                  method: "POST",
                  data: {
                    mobile: formData.mobile,
                    otp: formData.otp,
                  },
                  disableRedirect: true,
                });

                if (res.status) {
                  sessionStorage.setItem("authToken", res.data.auth_token);
                  localStorage.setItem("authToken", res.data.auth_token);
                  if (isGuardLogin) {
                    sessionStorage.setItem(
                      "auth_token_with_guard",
                      res.data.auth_token
                    );
                    localStorage.setItem(
                      "auth_token_with_guard",
                      res.data.auth_token
                    );
                  }
                  sessionStorage.setItem("displayName", res.data.agent_name);
                  await dispatch(
                    signInMember({
                      authToken: res.data.auth_token,
                      agentName: res.data.agent_name,
                      expiryTimestamp: res.data.expiry_timestamp,
                    })
                  );
                  dispatch(alert({ message: "Welcome!", type: "success" }));
                  navigate("/main-gate-entry-back");
                }
              } else {
                const res = await axios({
                  url: "/admin/member/login",
                  method: "POST",
                  data: {
                    username: formData.email,
                    password: formData.password,
                  },
                  disableRedirect: true,
                });

                if (res.status) {
                  sessionStorage.setItem("authToken", res.data.auth_token);
                  localStorage.setItem("authToken", res.data.auth_token);
                  if (isGuardLogin) {
                    sessionStorage.setItem(
                      "auth_token_with_guard",
                      res.data.auth_token
                    );
                    localStorage.setItem(
                      "auth_token_with_guard",
                      res.data.auth_token
                    );
                  }
                  sessionStorage.setItem("displayName", res.data.agent_name);
                  await dispatch(
                    signInMember({
                      authToken: res.data.auth_token,
                      agentName: res.data.agent_name,
                      expiryTimestamp: res.data.expiry_timestamp,
                    })
                  );
                  dispatch(alert({ message: "Welcome!", type: "success" }));
                  navigate("/guard-flow");
                }
              }
            } catch (error) {
              console.error("Login error:", error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {(formikProps) => (
            <form onSubmit={formikProps.handleSubmit}>
              <FormDisplay
                formikProps={formikProps}
                isOtpLogin={isOtpLogin}
                setIsOtpLogin={setIsOtpLogin}
                otpSent={otpSent}
                setOtpSent={setOtpSent}
              />
            </form>
          )}
        </Formik>
      </FormBox>
    </PageContainer>
  );
}
